export default __webpack_public_path__ + "static/media/404.24583a56.png";